<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title" v-text="title"></div>
        <DropdownScrollable :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @click="emitEvent" @keyup="emitEvent" @change="emitEvent" @offset="changeOffset"/>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model.sync="dataModel"
          :options="options"
          :filterDefault="filters"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange = 'DataOnChange'
          :company="company"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn chắc chắn muốn xóa?
          <template
            #footer
          >
            <Button
                label="Hủy"
                @click="showDeleteDialog = false"
                icon="pi pi-times"
                class="p-button-warning callback-btn"
              />
            <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import ApiRepository from "@/core/ApiRepository";
import BaseDatatable from './list'
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    BaseDatatable,
    DropdownScrollable
  },
  data() {
    return {
      filters : {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: null,
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
    }
  },
  async created() {
    await this.initParams();
    await this.getListCompany()
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    // console.log('this.dataModel:',this.dataModel);
    // this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company = {id: this.$route.query.company_id};
        setTimeout(() => {
          const query = Object.assign({}, this.$route.query);
          delete query.company_id;
          this.$router.replace({ query });
        }, 100);
      }
    }
  },
  watch: {
    '$route': 'initParams',
    'company'() {
      this.componentKey++;
    }
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.offset = value;
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
            this.items = res.data.data.company;
            this.total = res.data.data.total;
            this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      await this.$set(this, 'title', this.dataModel.label);
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (that.$store.getters.controllers?.list_sample && that.$store.getters.controllers?.list_sample.includes('add')) {
        actions.header = {name: 'add', icon: 'plus', path: `list-sample/add`};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.$store.getters.controllers?.list_sample && that.$store.getters.controllers?.list_sample.includes('edit')) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-sample/edit/`};
        }
        if (that.$store.getters.controllers?.list_sample && that.$store.getters.controllers?.list_sample.includes('delete')) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
    

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company?.id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/sample_license/delete", {id: that.deleteId, company_id: that.company.id}, {headers}).then(async function (response) {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
            that.$commonFuction.is_loading(false);
            that.componentKey += 1;
          } else {
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: response.data.message,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          if(err.response && err.response.data){
              if(err.response.data.message == "IS_USING_ERR"){
                that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: "Bạn không thể xoá danh mục chứa mối nguy đã được đánh giá.",
                  life: 3000
                });
              }
            }else{
              that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
              });
            }
        })
      }
    }
  },
}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-button-warning-o .p-button-label-o{
  color: #e95d57;
}
.p-button-warning .pi-times{
  color: #e95d57;
}
</style>